import api from '../../../services/api';

const URL = '/todo_categories';

const todoCategoryService = {
  getCategories() {
    return api.get(URL);
  },

  getCategory(id) {
    return api.get(`${URL}/${id}/`);
  },

  createCategory(data) {
    return api.post(URL, data);
  },

  updateCategory(id, data) {
    return api.put(`${URL}/${id}/`, data);
  },

  deleteCategory(id) {
    return api.delete(`${URL}/${id}/`);
  },
};

export default todoCategoryService;
